import { render, staticRenderFns } from "./hollandTest.vue?vue&type=template&id=04b9c186&scoped=true&"
import script from "./hollandTest.vue?vue&type=script&lang=js&"
export * from "./hollandTest.vue?vue&type=script&lang=js&"
import style0 from "./hollandTest.vue?vue&type=style&index=0&id=04b9c186&scoped=true&lang=less&"
import style1 from "./hollandTest.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b9c186",
  null
  
)

export default component.exports